{
  "pt": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Alterar logótipo (png necessário)",
        "changeThemeColor": "Escolher uma nova cor para o tema"
      },
      "errors": {
        "themeColorInvalid": "Introduza seis caracteres, 0-9 ou A-F. Por exemplo 096553."
      },
      "labels": {
        "customerThemeColor": "Cor do tema do cliente",
        "customerThemeColorExlainer": "Esta cor será utilizada para o portal do cliente. Faça-se passar por um cliente para ver isto em ação.",
        "logo": "Logótipo"
      },
      "paused": {
        "description": "A sua conta em {client} continua a existir, mas o seu acesso está desativado neste momento, por isso a plataforma continua fechada. Um proprietário da sua organização pode voltar a ativar o seu acesso.",
        "noAccess": "Sem acesso",
        "open": "Abrir",
        "title": "O seu acesso está em pausa",
        "yourOrganizations": "As suas organizações"
      },
      "picture_logo_format": {
        "round": "Logótipo redondo",
        "square": "Logótipo quadrado"
      }
    }
  }
}
